<template>
  <v-simple-table v-if="items?.length > 0" class="mb-4">
    <template v-slot:default>
      <thead>
        <tr>
          <th
            class="text-subtitle-2 text-md-subtitle-1 text-left grey--text text--darken-1 font-weight-bold"
          >
            Detalle
          </th>
          <th
            class="text-subtitle-2 text-md-subtitle-1 text-right grey--text text--darken-1 font-weight-bold"
          >
            Monto
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td class="text-subtitle-2 text-md-subtitle-1 font-weight-regular">
            {{ item.request_id }} {{ item.service }}
          </td>
          <td
            class="text-subtitle-2 text-md-subtitle-1 text-right font-weight-medium"
          >
            $ {{ item.amount }}
            <span v-show="ivaCondition === RESP_INSCRIPTO">+IVA</span>
          </td>
        </tr>
        <tr>
          <td
            class="text-subtitle-2 text-md-subtitle-1 text-uppercase font-weight-bold"
          >
            Total
          </td>
          <td
            class="text-subtitle-2 text-md-subtitle-1 text-right font-weight-bold"
          >
            $ {{ totalAmount }}
            <span v-show="ivaCondition === RESP_INSCRIPTO">+IVA</span>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters } from "vuex";
import { RESP_INSCRIPTO } from "@/helpers/constants";
export default {
  name: "InvoiceList",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      RESP_INSCRIPTO,
    };
  },
  computed: {
    ...mapGetters("invoice", ["ivaCondition"]),

    totalAmount() {
      return this.items
        .reduce((total, item) => total + parseFloat(item.amount || 0), 0)
        .toFixed(2);
    },
  },
};
</script>

<style>
</style>